<template>
  <svg
    width="7"
    height="8"
    viewBox="0 0 7 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="fill"
      d="M3.88297e-05 3.61716C-0.000925772 3.67628 0.0161017 3.7343 0.0488636 3.78352C0.0816254 3.83274 0.128574 3.87084 0.183485 3.89277L2.98359 5.01299L4.1038 7.81338C4.12544 7.86755 4.16283 7.91398 4.21112 7.94668C4.25942 7.97938 4.31642 7.99685 4.37474 7.99683H4.37941C4.43848 7.9959 4.49587 7.97705 4.54399 7.94278C4.59211 7.90851 4.62869 7.86044 4.64889 7.80492L6.98207 1.38869C7.00117 1.33649 7.00495 1.27993 6.99298 1.22565C6.98101 1.17137 6.95377 1.12165 6.91449 1.08233C6.8752 1.04301 6.82549 1.01574 6.77123 1.00372C6.71696 0.991707 6.66039 0.995449 6.60818 1.01451L0.191943 3.34768C0.136403 3.36793 0.0883195 3.40457 0.0540527 3.45274C0.019786 3.50091 0.000950865 3.55835 3.88297e-05 3.61746V3.61716Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "InlineLocationIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
